<template>
  <div class="wx-qrcode-popup-box">
    <div class="wx-qrcode-popup-box-dialog">
      <icon
        class="wx-qrcode-popup-box-dialog-close"
        type="close-grey"
        @click="close"
      ></icon>
      <div class="wx-qrcode-popup-box-dialog-text">
        接收学习提醒需要关注公众号「WPS学堂」在公众号-我的学习，还能快速打开你加入学习的课程。
      </div>
      <div class="wx-qrcode-popup-box-dialog-img">
        <img src="~/assets/image/wx-qrcode.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
  },

  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.wx-qrcode-popup-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
  &-dialog {
    position: absolute;
    width: 350px;
    height: 290px;
    margin-left: -175px;
    margin-top: -145px;
    left: 50%;
    top: 50%;
    border-radius: 12px;
    border: 1px solid rgba(17, 19, 23, 0.2);
    background-color: #ffffff;
    &-close {
      position: absolute;
      top: 14px;
      right: 14px;
      cursor: pointer;
    }
    &-text {
      margin-top: 38px;
      width: 270px;
      font-size: 14px;
      color: #111317;
      line-height: 22px;
      margin-left: 40px;
    }
    &-img {
      width: 136px;
      height: 136px;
      margin-top: 20px;
      margin-left: 107px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
